// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2ocU3","head":"Table_head__2LhBN","col":"Table_col__2aygy"};